const BASE = String(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

async function post(path, token, body, fallbackMessage) {
  const resp = await fetch(`${BASE}/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body || {}),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || data.success === false) {
    throw new Error(data.message || data.error || fallbackMessage);
  }
  return data;
}

/** Token format the backend middleware expects: `${sessionId}&${organizationId}`. */
export function sessionToken(sessionId, organizationId) {
  return sessionId && organizationId ? `${sessionId}&${organizationId}` : null;
}

/**
 * Settings + crossroads a player plays. `draft: true` = admin Preview (unpublished edits);
 * otherwise the published snapshot (falling back to the draft if never published).
 */
export function getGameContent({ token, draft = false, currentTheme = null, includeAnswers = false }) {
  return post("getGameContent", token, { draft, currentTheme, includeAnswers }, "Failed to load the game");
}

export function publishGame({ token, currentTheme }) {
  return post("publishGame", token, { currentTheme }, "Failed to publish the game");
}

export function getPublishStatus({ token, currentTheme }) {
  return post("getPublishStatus", token, { currentTheme }, "Failed to read publish status");
}

export function saveResponses({ token, userId, name, email, mode, responses, runId = null }) {
  return post("saveResponses", token, { userId, name, email, mode, responses, runId }, "Failed to save your answer");
}

/** Self-paced journey begins: the server starts the clock for the completion time. */
export function startJourney({ token, userId, name, email, userType, reportId }) {
  return post("startJourney", token, { userId, name, email, user_type: userType, reportid: reportId }, "Failed to start the journey");
}

/** Live: the player is in this run's room (counts them as a participant even if they never vote). */
export function joinLiveRun({ token, runId, userId, name, email, userType, reportId }) {
  return post("joinLiveRun", token, { runId, userId, name, email, user_type: userType, reportid: reportId }, "Failed to join the live game");
}

export function completeJourney({ token, userId, name, email, mode, timeSeconds, userType, reportId, runId = null }) {
  return post(
    "completeJourney",
    token,
    { userId, name, email, mode, timeSeconds, user_type: userType, reportid: reportId, runId },
    "Failed to save your result"
  );
}

export function saveLiveResult({ token, runId, questionId, questionIndex }) {
  return post(
    "saveLiveResult",
    token,
    { runId, questionId, questionIndex },
    "Failed to save live result"
  );
}

export function getReports({ token }) {
  return post("getReports", token, {}, "Failed to load reports");
}


/** Post-game feedback (one of the emoji choices) → stages.feedback. */
export function saveFeedback({ token, userId, feedback }) {
  return post("saveFeedback", token, { userId, feedback }, "Failed to save your feedback");
}
